import { ShopDefaultAddressSwitchVo, AuthPageListUsingGetParams, GylErpShopInfo9, QueryListUsingGetParams, GylErpShopInfo8, PageShopForDisGoodsUsingGetParams, ErpShopParam, GetShopAuthUrlUsingGetParams, GetShopIconAuthUrlUsingGetParams, ListShopTypeUsingGet1Params, ShopTypeVo, GetShopInfoUsingGet1Params, GylErpShopInfo, ListPageUsingGetParams, ShopRefundOrderListUsingGetParams, OpShopRefundOrderVo, QueryShopMultiVersionAuthUrlUsingGetParams, CheckCanApplyRefundParam, CheckCanApplyRefundVo, PageAuthShopsUsingGetParams, UpdateDownloadAfterSaleParam, GetOrderDownloadConfigUsingGetParams, OrderDownloadConfigVo, DownloadOrderParam, AuthPageListV2UsingGetParams, GylErpShopInfo11, PageShopForDisGoodsFilteredByUserShopAuthUsingGetParams, GylErpShopInfo1
} from '@servicesTypings/companyRequest'
import {
    ManualUpdateShopItemParam, DownloadShopSiteVo, ShopItemDownloadVo, DownloadItemResultVo, QueryDownloadProcessV2UsingGetParams, DownloadProcessNewVo, ClearTaoBaoShopRickMarkParam, Shop } from '@servicesTypings/goodsRequest'
import { QuerySyncStockUsingGetParams } from '@servicesTypings/drpRequest'
import { companyRequest, goodsRequest, drpRequest } from '@/utils/request'

// 查询店铺 带权限的二次校验
/**
 * 查询店铺列表（权限控制及分页
 */
export function queryAuthShopList(params: AuthPageListUsingGetParams): API.Res<GylErpShopInfo9[]> {
    return companyRequest.get('/shop/auth/pageList', { params })
}

/** 查询店铺列表（权限控制及分页） */
export function queryShopList(params: AuthPageListV2UsingGetParams): API.Res<GylErpShopInfo11[]> {
    return companyRequest.get('/shop/auth/pageListV2', { params })
}

// 删除店铺
/**
 * 删除店铺 (转换包含中文无法完全转换)
 */
export function deleteShop(data: any): API.Res<boolean> {
    return companyRequest.post('/shop/deleteShop', { data })
}

// 更新店铺名称
/**
 * 更新店铺名称 (转换包含中文无法完全转换)
 */
export function updateShopNameApi(data: any): API.Res<boolean> {
    return companyRequest.post('/shop/updateShopName', { data })
}

// 查询店铺(无分页)
/**
 * 店铺列表
 */
export function queryShopListNoPage(params: QueryListUsingGetParams): API.Res<GylErpShopInfo8[]> {
    return companyRequest.get('/shop/list', { params })
}

// 查询店铺不带退款逻辑，用于同步供应商库存
/**
 * 供销商品列表-查询店铺列表（用于库存同步）
 */
export function queryShopListForDisGoods(params: PageShopForDisGoodsUsingGetParams): API.Res<GylErpShopInfo9[]> {
    return companyRequest.get('/shop/pageShopForDisGoods', { params })
}

// 手动下载店铺商品资料
/**
 * 手动下载店铺商品资料
 */
export function manualDownloadShopItem(data: ManualUpdateShopItemParam): API.Res<object> {
    return goodsRequest.post('/online/goods/manualDownloadShopItem', { data })
}

// 新增店铺
/**
 * 新增店铺
 */
export function addStore(data: ErpShopParam): API.Res<object> {
    return companyRequest.post('/shop/add', { data })
}

// 修改店铺
/**
 * 修改店铺
 */
export function updateStore(data: ErpShopParam): API.Res<object> {
    return companyRequest.post('/shop/update', { data })
}

// 批量修改店铺
/**
 * 批量修改店铺-一键开启售后下载
 */
export function batchUpdateStore(data: ErpShopParam[]): API.Res<object> {
    return companyRequest.post('/shop/batch/update', { data })
}

// 修改店铺的库存同步
/**
 * 修改店铺库存同步
 */
export function updateSyncStock(data: ErpShopParam): API.Res<object> {
    return companyRequest.post('/shop/updateSyncStock', { data })
}

// 获取授权url
/**
 * 获取店铺授权链接
 */
export function queryAuthUrl(params: GetShopAuthUrlUsingGetParams): API.Res<object> {
    return companyRequest.get('/joinLoginErp/authUrl', { params })
}

// 淘宝、天猫直接授权
/**
 * 平台图标点击去获取授权 ，目前只支持 淘宝/天猫
 */
export function queryTaoAuthUrl(params: GetShopIconAuthUrlUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/getShopIconAuthUrl', { params })
}

// 查询店铺站点
/**
 * 查询店铺站点列表
 */
export function queryShopSiteList(params: ListShopTypeUsingGet1Params): API.Res<ShopTypeVo[]> {
    return companyRequest.get('/shop/listShopType', { params })
}

// 查询店铺详情
/**
 * 店铺详情
 */
export function queryShopInfo(params: GetShopInfoUsingGet1Params): API.Res<GylErpShopInfo> {
    return companyRequest.get('/shop/getShopInfo', { params })
}

// 查询erp店铺列表
/**
 * 查询erp商家店铺信息列表
 */
export function queryListPage(params: ListPageUsingGetParams): API.Res<GylErpShopInfo9[]> {
    return companyRequest.get('/erpShopInfo/listPage', { params })
}

// 查询店铺退款单列表
/**
 * 查询店铺退款单列表
 */
export function queryShopRefundOrderList(params: ShopRefundOrderListUsingGetParams): API.Res<OpShopRefundOrderVo[]> {
    return companyRequest.get('/op/refundOrder/shopRefundOrderList', { params })
}

// 查询待初审数量
/**
 * 查询待初审数量
 */
export function queryFirstCheckCountApi(): API.Res<object> {
    return companyRequest.get('/op/refundOrder/waitFirstCheckCount')
}

// 查询即将过期/已过期的店铺列表
export function getExpiredShop() {
    return companyRequest.get('/shop/pageExpiredShop')
}
// 查询【启用】且【已授权】且【店铺库存同步未开启】的店铺主账号列表
export function getCountNoSyncStockShop() {
    return companyRequest.get('/shop/countNoSyncStockShop')
}

// 快手店铺授权的过来 店铺创建并授权
export function shopCreate(data) {
    const { scmId } = data
    return companyRequest.post(`/shop/create?scmId=${scmId}`, {
        data
    })
}

/**
 * 查询店铺多版本授权链接
 */
/**
 * 查询店铺多版本授权链接
 */
export function queryShopMultiVersionAuthUrl(params: QueryShopMultiVersionAuthUrlUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/queryShopMultiVersionAuthUrl', { params })
}

// 校验是否可申请退款
/**
 * 校验是否可申请退款
 */
export function checkCanApplyRefundV2(data: CheckCanApplyRefundParam): API.Res<CheckCanApplyRefundVo> {
    return companyRequest.post('/refundOrder/checkCanApplyRefundV2', { data })
}

// 查询店铺列表-只包含支持上架的店铺类型
/**
 * 查询店铺列表-只包含支持上架的店铺类型
 */
export function pageAuthShops(params: PageAuthShopsUsingGetParams): API.Res<GylErpShopInfo9[]> {
    return companyRequest.get('/shop/pageAuthShops', { params })
}

// 获取当前商家的店铺下载支持的平台
/**
 * 获取当前商家的店铺下载支持的平台
 */
export function getSelfShopSiteInfo(): API.Res<DownloadShopSiteVo[]> {
    return goodsRequest.get('/shopManage/getSelfShopSiteInfo')
}

// 下载店铺商品资料
/**
 * 下载店铺商品资料
 */
export function downloadShopItem(data: ShopItemDownloadVo): API.Res<DownloadItemResultVo> {
    return goodsRequest.post('/shopManage/downloadShopItem', { data })
}

// 查询店铺商品资料下载进度
/**
 * 查询店铺商品资料下载进度
 */
export function queryDownloadProcess(params: QueryDownloadProcessV2UsingGetParams): API.Res<DownloadProcessNewVo> {
    return goodsRequest.get('/shopManage/queryDownloadProcessV2', { params })
}

// 修改下载售后单
/**
 * 修改下载售后单
 */
export function updateDownloadAfterSale(data: UpdateDownloadAfterSaleParam): API.Res<null> {
    return companyRequest.post('/shop/updateDownloadAfterSale', { data })
}

// 查询库存同步开关
/**
 * 查询同步供应商控价开关状态
 */
export function querySyncStock(params: QuerySyncStockUsingGetParams): API.Res<boolean> {
    return drpRequest.get('/partner/channel/querySyncStock', { params })
}

// 获取补拉配置
/**
 * 获取补拉配置
 */
export function getOrderDownloadConfig(params: GetOrderDownloadConfigUsingGetParams): API.Res<OrderDownloadConfigVo> {
    return companyRequest.get('/shop/getOrderDownloadConfig', { params })
}

// 补拉订单售后单(异步)
/**
 * 补拉订单售后单(异步)
 */
export function downloadOrder(data: DownloadOrderParam): API.Res<boolean> {
    return companyRequest.post('/shop/downloadOrder', { data })
}

/**
 * 获取店铺发货/退货地址
 * @returns {Promise}
 **/
/**
 * 获取店铺平台退货地址默认开关
 */
export function queryPlatformAddress(data: string[]): API.Res<ShopDefaultAddressSwitchVo[]> {
    return companyRequest.post('/shop/address/queryPlatformAddressSwitch', { data })
}

/**
 * 供销商品列表-查询店铺列表（用于库存同步）
 */
export function pageShopForDisGoodsFilteredByUserShopAuthUsingGET(
    params: PageShopForDisGoodsFilteredByUserShopAuthUsingGetParams
): API.Res<GylErpShopInfo1[]> {
    return companyRequest.get('/shop/pageShopForDisGoodsFilteredByUserShopAuth', { params })
}

/**
* 清除淘宝核身风险提示标记 
*/
export function clearTaoBaoShopRiskMarkUsingPOST(data: ClearTaoBaoShopRickMarkParam): API.Res<null> {
    return goodsRequest.post('/shelves/mxStoresInformation/clearTaoBaoShopRiskMark', { data })
}

/**
* 获取淘宝核身风险提示链接 
*/
export function getTaoBaoShopRiskVerifyUrlUsingPOST(data: ClearTaoBaoShopRickMarkParam): API.Res<Shop[]> {
    return goodsRequest.post('/shelves/mxStoresInformation/getTaoBaoShopRiskVerifyUrl', { data })
}
